import { GET } from "../../helper/xbi4RestFunctions";

export const getUserReportsTo = async (org_id: any) => {
  const path = `/orgs/${org_id}/reports_to`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching users > ", err);
      return err;
    });
};
